import { API } from './resources'

export default {
  updateProjectPin: (pinURL, projectID) => {
    return API.put(`/project/${projectID}/projectPin`, { url: pinURL })
  },
  getProjectPin: (projectID) => {
    return API.get(`/project/getProjectPin/${projectID}`)
  },
  collectProjectPin: (projectID) => {
    return API.post(`/project/collectPin/${projectID}`)
  }
}
